export default function useDataConfiguration(props) {
  return {
    requestPolicy: 'cache-and-network',
  }
}
